(function () {
  angular.module('MktzapApp.Controllers')
    .controller('PdvController', pdvController);

  pdvController.$inject = ['$scope', 'PdvService', 'FoundationApi', 'NotificationService', 'LangService', '$rootScope'];

  function pdvController ($scope, PdvService, FoundationApi, NotificationService, LangService, $rootScope) {
    var vm = this;
    vm.tablePdvs = [];
    vm.pdvs = {};
    vm.pdv = {};
    vm.pdvEdit = {};

    LangService
        .getPageLabels({ 'page': 'menu.master.pdv' })
        .$promise
        .then(function (data) {
            vm.labels = data.lang;
        });

    getPdvs();

    vm.cleanFilter = function () {
        vm.pdv = {};
        vm.filterPDVs();
    }

    vm.filterPDVs = function() {
        vm.tablePdvs = [];
        vm.pdvs.forEach(pdv => {
            let add = true;
            Object.keys({puntoVenta: pdv.puntoVenta, company: pdv.company, type: pdv.type})
                .forEach(function (key) {
                    if (pdv[key] && vm.pdv[key] && pdv[key] != vm.pdv[key]) {
                	    add = false;
                    }
            });
            if (add) {
            	vm.tablePdvs.push(pdv);
            }
       });
    }

    function getPdvs() {
        PdvService
            .getAllPdvs()
            .$promise
            .then(function (data) {
                if (data.pdvs) {
                    vm.pdvs = data.pdvs;
                    vm.tablePdvs = data.pdvs;
                } else {
                    NotificationService.errorHandler(data, vm.labels.errorGetInfo);
                }
            }).catch(function (data) {
                NotificationService.errorHandler(data, vm.labels.errorOperation);
            });
    }

    vm.addPdvModal = function () {
        vm.pdv = {};
        FoundationApi.publish('registerPdvModal', 'open');
    }

    vm.editPdvModal = function (pdvId) {
        vm.pdvEdit = {};
        PdvService
            .getPdvById({id: pdvId})
            .$promise
            .then(function (data) {
                if (data.pdv) {
                    vm.pdvEdit.id = data.pdv._id;
                    vm.pdvEdit.puntoVenta = data.pdv.puntoVenta;
                    vm.pdvEdit.company = data.pdv.company;
                    vm.pdvEdit.type = data.pdv.type;
                    FoundationApi.publish('editPdvModal', 'open');
                } else {
                    NotificationService.errorHandler(data, vm.labels.error);
                }
            }).catch(function (data) {
                NotificationService.errorHandler(data, vm.labels.error);
            });
    }

    vm.savePDV = function (save = true) {
        pdvExist(save).then(function (exist) {
            if (exist.pdv == null) {
                if (save) {
                    vm.save();
                } else {
                    vm.saveEdit();
                }
            } else if (exist.pdv._id == vm.pdvEdit.id){
                vm.saveEdit();
            } else {
                console.log("NotificationService.errorHandler");
                NotificationService.errorHandler([], vm.labels.alertErrorNumPDVExist);
            }
        });
    }

    vm.save = function () {
        
        if (!vm.pdv.type || !vm.pdv.company || !vm.pdv.puntoVenta) {
            NotificationService.errorHandler([], vm.labels.alertErrorInputsEmpaty);
            return;
        }

        if (isNaN(vm.pdv.puntoVenta) || vm.pdv.puntoVenta.length != 6) {
            NotificationService.errorHandler([], vm.labels.alertErrorLengthNumPDV);
            return;
        }

        PdvService
            .store(vm.pdv)
            .$promise
            .then(function (data) {
                getPdvs();
                vm.pdv = {};
                NotificationService.successHandler([], vm.labels.dataSaved);
                FoundationApi.publish('registerPdvModal', 'close');
            }).catch(function () {
                NotificationService.errorHandler([], vm.labels.errorOperation);
            });
    }

    vm.delete = function (pdvId) {
        PdvService
            .delete({id: pdvId})
            .$promise
            .then(function (data) {
                getPdvs();
                if (data.success) {
                    NotificationService.successHandler(data, vm.labels.successDelData);
                }
            }).catch(function (data) {
                NotificationService.errorHandler(data, vm.labels.internalServerError);
            });
    }

    function pdvExist(save) {
        if (save) {
            save = {puntoVenta: vm.pdv.puntoVenta};
        } else {
            save = {puntoVenta: vm.pdvEdit.puntoVenta};
        }
        return PdvService
            .getExistspuntoVenda(save)
            .$promise.catch(function () {
                NotificationService.errorHandler([],  vm.labels.alertErrorQueryPDV);
            });
    }

    vm.saveEdit = function (data) {
        
        if (!vm.pdvEdit.type || !vm.pdvEdit.company || !vm.pdvEdit.puntoVenta) {
            NotificationService.errorHandler(data, vm.labels.alertErrorInputsEmpaty);
            return;
        }

        if (isNaN(vm.pdvEdit.puntoVenta) || vm.pdvEdit.puntoVenta.length != 6) {
            NotificationService.errorHandler(data, vm.labels.alertErrorLengthNumPDV);
            return;
        }
        
        PdvService
            .update(vm.pdvEdit)
            .$promise
            .then(function (data) {
                getPdvs();
                vm.pdvEdit = {};
                NotificationService.successHandler(data, vm.labels.updatedWithSuccess);
                FoundationApi.publish('editPdvModal', 'close');
            }).catch(function (data) {
                NotificationService.errorHandler(data, vm.labels.internalServerError);
            });
    }

  }
})();
